import styled from 'styled-components';
import LogoIcon from '@/assets/pc/Logo.svg?react';
import ArrowDownIcon from '@/assets/pc/Arrow-Down.svg?react';
import AvatarIcon from '@/assets/pc/Avatar.svg?react';
import { useNavigate, Link } from 'react-router-dom';
import { kakaoLogin } from '@/api/auth';
import { useAuthStore } from '@/store/useAuthStore';

const Header = () => {
  const navigate = useNavigate();

  const user = useAuthStore((state) => state.user);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const handleKakaoLogin = async () => {
    try {
      const { url } = await kakaoLogin(); // ✅ 받은 URL 추출
      console.log('✅ 카카오 로그인 URL:', url);

      window.location.href = url; // ✅ 카카오 로그인 페이지로 이동
    } catch (error) {
      console.error('❌ 로그인 오류:', error);
    }
  };

  const handleLogout = () => {
    useAuthStore.getState().logout(); // 상태 초기화
    localStorage.removeItem('auth-storage'); // ✅ persist된 항목 삭제
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/'); // 필요 시 리디렉션
  };

  return (
    <HeaderContainer>
      <HeaderInner>
        <LeftWrapper onClick={() => navigate('/')}>
          <LogoIcon />
        </LeftWrapper>

        <CenterWrapper>
          <MenuItem onClick={() => navigate('/appointment')}>손사선임</MenuItem>
          <MenuItem onClick={() => (window.location.href = 'https://nicetomeetyou.oopy.io/')}>
            전화상담
          </MenuItem>
          <MenuItem onClick={() => (window.location.href = 'https://www.hiadjuster.com/review')}>
            후기
          </MenuItem>

          <DropdownWrapper>
            <DropdownToggle>
              이용안내
              <ArrowDownIcon />
            </DropdownToggle>

            <DropdownBox>
              <DropdownList>
                <DropdownItem as={Link} to="/intro/news">
                  최신소식
                </DropdownItem>
                <DropdownItem as={Link} to="/intro/faq">
                  자주 묻는 질문
                </DropdownItem>
                <DropdownItem as={Link} to="/intro/adjusters">
                  손사 소개
                </DropdownItem>
                <DropdownItem as={Link} to="/intro/about">
                  올받음 소개
                </DropdownItem>
              </DropdownList>
            </DropdownBox>
          </DropdownWrapper>
        </CenterWrapper>

        <RightWrapper>
          <RightInner>
            <ApplyButton onClick={() => navigate('/appointment')}>
              <ApplyText>선임 신청하기</ApplyText>
            </ApplyButton>

            {isLoggedIn && user ? (
              <UserInfo>
                <AvatarIcon />
                <UserNameText>{user.username}님</UserNameText>
                <LogoutText onClick={handleLogout}>로그아웃</LogoutText>
              </UserInfo>
            ) : (
              <LoginButton onClick={handleKakaoLogin}>
                <AvatarIcon />
                <LoginText>로그인</LoginText>
              </LoginButton>
            )}
          </RightInner>
        </RightWrapper>
      </HeaderInner>
    </HeaderContainer>
  );
};

export default Header;

// ===================== 스타일 =====================

const HeaderContainer = styled.header`
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  position: fixed; // ✅ 고정
  top: 0; // ✅ 화면 상단에 붙임
  left: 0;
  z-index: 1000; // ✅ 겹치지 않도록 z-index 충분히 높임
`;

const HeaderInner = styled.div`
  margin: 0 auto;
  padding: 16px 0;
  display: flex;
  align-items: center;
  max-width: 1230px;
  justify-content: space-between;
  gap: 16px;
`;

const LeftWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  cursor: pointer; // ✅ 추가
`;

const CenterWrapper = styled.nav`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap; // ✅ 줄바꿈 방지
  min-width: 0; // ✅ overflow 잘 처리
`;

const RightWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const MenuItem = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 8px;

  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.32px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: #f0f3fe;
  }
`;

const DropdownToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 12px 16px;
  height: 48px; // ✅ 고정 높이 지정
  min-width: 120px; // ✅ 최소 너비 지정
  border-radius: 4px;

  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.32px;
  cursor: pointer;

  &:hover {
    background-color: #f0f3fe;
  }
`;

const DropdownBox = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: clamp(200px, 35vw, 396px);
  padding: 16px 34px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  background: #f8fafd;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  ${DropdownBox} {
    display: none;
  }

  &:hover ${DropdownBox} {
    display: flex;
  }
`;

const DropdownList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

const DropdownItem = styled(Link)`
  display: flex;
  padding: 19px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  cursor: pointer;

  flex: 1 0 0;
  color: #000c24;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.36px;
  text-decoration: none;

  &:hover {
    color: var(--Primary-brand_01, #0b46dd);
    font-weight: 700;
  }
`;

const RightInner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ApplyButton = styled.button`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  height: 48px;
  padding: 16px 12px;
  border-radius: 8px;
  background: var(--Primary-brand_01, #0b46dd);
  border: none;
  cursor: pointer;
`;

const ApplyText = styled.span`
  display: flex;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: var(--Primary-white, #fff);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const LoginButton = styled.button`
  display: flex;
  padding: 12px 8px;
  height: 48px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--Primary-lightgray, #f3f3f3);
  border: none;
  cursor: pointer;
`;

const LoginText = styled.span`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.32px;
`;

const UserInfo = styled.div`
  display: flex;
  padding: 12px 8px;
  height: 48px;
  align-items: center;
  gap: 8px;
`;

const UserNameText = styled.span`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.32px;
`;

const LogoutText = styled.span`
  color: #ff4d4f; /* ✅ 진한 빨간색 (Ant Design의 danger red) */
  font-size: 14px;
  font-weight: 600; /* ✅ 조금 굵게 */
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    color: #d9363e; /* ✅ 호버 시 더 진한 빨간색 */
  }
`;
